import { render, staticRenderFns } from "./edit-draft.vue?vue&type=template&id=7ec10936&"
import script from "./edit-draft.vue?vue&type=script&lang=js&"
export * from "./edit-draft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ec10936')) {
      api.createRecord('7ec10936', component.options)
    } else {
      api.reload('7ec10936', component.options)
    }
    module.hot.accept("./edit-draft.vue?vue&type=template&id=7ec10936&", function () {
      api.rerender('7ec10936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/message/edit-draft.vue"
export default component.exports